// store
import { atom } from 'recoil';

const calendarFullScreenAtom = atom<boolean>({
  key: 'calendarFullScreenAtom',
  default: false
});

export { calendarFullScreenAtom };
